<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="ack">ACKNOWLEDGMENTS</p>
<p class="tni">My thanks to <span class="epub-i">People</span> Managing Editor Landon Y. Jones, my editors, Roger Wolmuth, Joe Treen and Jack Friedman, and <span class="epub-i">People</span> correspondents Don Sider and Gail Wescott. I also want to express my sincere gratitude to <span class="epub-i">People</span> Senior Writer Cynthia Sanz for editing this book and for all of her support.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?90c554fc